import type { LocationBlokData } from '../components/blocks/location/Location.data';

export const filterLocations = (location: LocationBlokData, searchValue: string): boolean => {
  const normalizedSearchValue = searchValue
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '');

  return (
    location.city
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036F]/g, '')
      .includes(normalizedSearchValue) ||
    location.country
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036F]/g, '')
      .includes(normalizedSearchValue) ||
    (location.title || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036F]/g, '')
      .includes(normalizedSearchValue)
  );
};
